import { useState } from "react";
import { Search, X, SlidersHorizontal, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { DateField } from "@/components/news/DateField";

export const FilterBar = ({ sources, filters, set, hasActiveFilters, clearFilters }) => {
  const {
    selectedSource,
    dateFrom,
    dateTo,
    searchInput,
  } = filters;

  const [open, setOpen] = useState(false);

  const advancedActive =
    selectedSource !== "all" ||
    !!dateFrom ||
    !!dateTo;

  return (
    <div className="sticky top-[73px] z-40 bg-background/90 backdrop-blur-xl border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
            <Input
              data-testid="search-input"
              placeholder="Buscar..."
              value={searchInput}
              onChange={(e) => set.setSearchInput(e.target.value)}
              className="rounded-none border-border h-10 pl-10 pr-10"
            />
            {searchInput && (
              <button
                data-testid="search-clear"
                onClick={() => set.setSearchInput("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                aria-label="Borrar búsqueda"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
          <Button
            data-testid="toggle-filters-button"
            variant="outline"
            onClick={() => setOpen((o) => !o)}
            className={`relative rounded-none h-10 gap-2 shrink-0 ${open || advancedActive ? "border-primary text-primary" : "border-border"}`}
          >
            <SlidersHorizontal className="w-4 h-4" />
            <span className="hidden sm:inline">Filtros</span>
            {advancedActive && (
              <span
                data-testid="filters-active-dot"
                className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-primary rounded-full"
              />
            )}
            <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
          </Button>
        </div>

        {open && (
          <div
            className="flex flex-wrap items-end gap-3 pt-3 animate-in fade-in slide-in-from-top-2 duration-200"
            data-testid="filter-bar"
          >
            <div className="flex flex-col gap-1">
              <label className="text-[10px] uppercase tracking-widest font-semibold text-muted-foreground">Fuente</label>
              <Select value={selectedSource} onValueChange={set.setSelectedSource}>
                <SelectTrigger data-testid="source-filter" className="w-[170px] rounded-none border-border h-9">
                  <SelectValue placeholder="Fuente" />
                </SelectTrigger>
                <SelectContent className="rounded-none max-h-[300px]">
                  <SelectItem value="all" data-testid="source-option-all">Todas las fuentes</SelectItem>
                  {sources.map((s) => (
                    <SelectItem key={s.id} value={s.name} data-testid={`source-option-${s.id}`}>
                      {s.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <DateField label="Desde" value={dateFrom} onChange={set.setDateFrom} testId="date-from-filter" />
            <DateField label="Hasta" value={dateTo} onChange={set.setDateTo} testId="date-to-filter" />

            {hasActiveFilters && (
              <Button
                variant="ghost"
                data-testid="clear-filters-button"
                onClick={clearFilters}
                className="rounded-none h-9 gap-2 text-muted-foreground hover:text-foreground"
              >
                <X className="w-4 h-4" />
                Limpiar
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
